export const conditionActionTypes = {
  ADD_CONDITION: 'ADD_CONDITION',
  REMOVE_CONDITION: 'REMOVE_CONDITION',
  UPDATE_CONDITION: 'UPDATE_CONDITION',
  CLEAR_CONDITION: 'CLEAR_CONDITION',
}
